module.exports = __webpack_public_path__ + "static/media/awardslogo.480e1cb8.png";